define.alias("shared/modifiers/focus-on-destruct", "media/modifiers/focus-on-destruct");